import { j as o } from "./index.es33.js";
import { t } from "./index.es106.js";
import { Typography as p } from "./index.es35.js";
import "./index.es36.js";
import e from "./index.es571.js";
var x = function x(_ref) {
  var n = _ref.page,
    r = _ref.perPage,
    s = _ref.total,
    i = _ref.children;
  var m = "".concat(r * (n - 1) + 1, " - ").concat(Math.min(r * n + (n > 1 ? 1 : 0), s));
  return o.jsxs("div", {
    className: e.infoContainer,
    children: [o.jsxs(p.Body2, {
      children: [o.jsx("span", {
        children: t("component_component_paginatorInfoLabel_showing")
      }), " ", m, " ", o.jsx("span", {
        children: t("component_component_paginatorInfoLabel_outOf")
      }), " ", s]
    }), i]
  });
};
export { x as Info };